export default __webpack_public_path__ + "static/media/peter-min.4ad51aac.png";